// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Qdyp","item":"PaymentsMobile_item__1oG5-","label":"PaymentsMobile_label__1UzHW","amount":"PaymentsMobile_amount__t0JFH"};